webpackJsonp(["validate-form"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/components/validate-form/validate-form.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("validate-form");

var ValidateForm = function () {
	function ValidateForm(element, options) {
		_classCallCheck(this, ValidateForm);

		log("element", element);
		log("options", options);

		this.options = options;
		this.form = element;

		this.formElements = [].concat(_toConsumableArray(this.form.querySelectorAll("input,select,fieldset[data-required]")));

		// Elements that may have error messages to display
		this.componentErrorCollection = [].concat(_toConsumableArray(this.form.querySelectorAll(this.options.componentErrorSelector)));

		this.watch();

		log("ready", this, this.form);
	}

	_createClass(ValidateForm, [{
		key: "watch",
		value: function watch() {
			log("watching");
			this.form.addEventListener("submit", this.onFormSubmit.bind(this));
		}
	}, {
		key: "isInvalid",
		value: function isInvalid() {
			return this.formElements.map(function (element) {

				//	data-required used as a proxy for required property on validated fieldset elements
				if (element.dataset.required === 'true') {
					return element.validity.valid;
				}
				if (element.dataset.required === 'false') {
					return true;
				}

				return element.validity.valid;
			}).includes(false);
		}
	}, {
		key: "showErrors",
		value: function showErrors() {
			this.componentErrorCollection.forEach(function (component) {
				component.dataset.showErrors = true;
			});
		}
	}, {
		key: "onFormSubmit",
		value: function onFormSubmit(event) {
			if (this.isInvalid()) {
				event.preventDefault();
				this.showErrors();
			}
		}
	}]);

	return ValidateForm;
}();

ValidateForm.DEFAULTS = {
	componentErrorSelector: "[data-show-errors]"
};

exports.default = ValidateForm;

/***/ })

});


// WEBPACK FOOTER //
// scripts/validate-form--bfcbcbda9f6c1ed21324.js